import * as React from 'react';
import * as style from './FactsWrapper.css';
import { clsx } from 'clsx';

interface IFactsWrapperProps {
  children: React.ReactNode[];
}

export const FactsWrapper = ({ children }: IFactsWrapperProps) => {
  return (
    <div className={style['wrapper']}>
      <ul className={clsx(style['inner'], children.length < 4 && style['inner--short'])}>{children}</ul>
    </div>
  );
};
